// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"bd0704c0","687":"090f1341"}[chunkId] + ".chunk.css";
};